import React from 'react';
import { List, Edit, Create, Datagrid, SimpleForm, required,
		TextField, BooleanField, UrlField, NumberField,
		TextInput, BooleanInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton,TabbedForm, FormTab, ReferenceManyField  } from 'admin-on-rest';

import { FieldTypes } from '../utils/enums';

export const PlanFieldCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect={`/admin/cloudhintsdomains/${window.location.href.substring(window.location.href.lastIndexOf('_id=')+4)}`}>

			<TextInput source="field_label" label="Veld label (bijv: Geschikt voor accountants?)" />
			<TextInput source="field_key"   label="Veld code (bijv: geschiktvoor_accountant)" />		
			
			<NumberInput source="field_maxlength"  label="Maximum lengte (tekens)" />
			<NumberInput source="field_order" label="Volgorde, hoger getal is hogere positie" />			
			<SelectInput source="field_type" label="Type invoer" choices={FieldTypes} optionText="value" optionValue="value"  />			
			<BooleanInput source="field_required" label="Verplicht veld?" />
					
			<NumberInput source="cloudhintsdomains_id" defaultValue={window.location.href.substring(window.location.href.lastIndexOf('_id=')+4)} />
			
        </SimpleForm>
    </Create>
);

export const PlanFieldEdit = (props) => (
    <Edit title="Edit" {...props}>
        <SimpleForm redirect={`/admin/cloudhintsdomains/${window.location.href.substring(window.location.href.lastIndexOf('_id=')+4)}`}>
			<TextInput source="field_label" label="Veld label (bijv: Geschikt voor accountants?)" />
			<TextInput source="field_key"   label="Veld code (bijv: geschiktvoor_accountant)" />		
			
			<NumberInput source="field_maxlength"  label="Maximum lengte (tekens)" />
			<NumberInput source="field_order" label="Volgorde, hoger getal is hogere positie" />			
			<SelectInput source="field_type" label="Type invoer" choices={FieldTypes} optionText="value" optionValue="value"  />			
			<BooleanInput source="field_required" label="Verplicht veld?" />
					
			<NumberInput source="cloudhintsdomains_id" />
		
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/cloudhints_domains/Planfield.js